import { IconProps } from '@pulsex/types';

export const FollowIcon = ({ className, size = 20 }: IconProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="-100 0 750 550"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M178.3 304H237.7C331.782 304 408 380.218 408 474.3C408 486.282 398.282 496 386.3 496H29.7002C17.7185 496 8 486.282 8 474.3C8.0001 380.218 84.2182 304 178.3 304ZM496 96C504.882 96 512 103.118 512 112V168H568C576.882 168 584 175.118 584 184C584 192.882 576.882 200 568 200H512V256C512 264.882 504.882 272 496 272C487.118 272 480 264.882 480 256V200H424C415.118 200 408 192.882 408 184C408 175.118 415.118 168 424 168H480V112C480 103.118 487.118 96 496 96ZM208 8C269.882 8 320 58.1183 320 120C320 181.882 269.882 232 208 232C146.118 232 96 181.882 96 120C96 58.1183 146.118 8 208 8Z"
                strokeWidth="60"
            />
        </svg>
    );
};
